import * as React from 'react';
import { Flex as Flex_, FlexProps } from 'grid-styled';

const DEFAULT_ALIGNITEMS = 'flex-start';
const DEFAULT_FLEXDIRECTION = 'column';

export const Flex: React.SFC<FlexProps> = (props) => {
    const {alignItems, justifyContent, flexDirection, flexWrap, style} = props;
    return (
        <Flex_
            alignItems={alignItems ? alignItems : DEFAULT_ALIGNITEMS}
            flexDirection={flexDirection ? flexDirection : DEFAULT_FLEXDIRECTION}
            justifyContent={justifyContent}
            flexWrap={flexWrap}
            style={style}
        >
            {props.children}
        </Flex_>
    );
};



// WEBPACK FOOTER //
// ./src/CommonUI/Layout/Flex.tsx